export default "__VITE_PUBLIC_ASSET__f7b1ca35__"